'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function city() {
    return {
        id: 'city',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-city',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.city.placeholder'),
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.city.required-error'),
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.minLength(2),
                message: magicCommon.translate('sign-up-step-two.city.min-length-error'),
            },
            {
                name: 'max-length',
                fn: magicFormBuilder.maxLength(50),
                message: magicCommon.translate('sign-up-step-two.city.max-length-error'),
            },
            {
                name: 'not-only-whitespaces',
                fn: magicFormBuilder.notOnlyWhitespaces,
                message: magicCommon.translate('sign-up-step-two.city.not-only-whitespaces-error'),
            },
        ],
    };
}

exports.city = city;
